import Cookies from 'js-cookie';

import UserStore from '~/state/user';

import analyticsStore from './Analytics.store';

const getBaseTrackingData = () => {
  // Ensures the page is not `/home` which is just a redirect for rapid auth
  const page =
    window.location.pathname === '/home' ? '/' : window.location.pathname;

  // Using snakecase here to share consistency with web app tracking properties
  const rapidAuthEnabledCookie = Cookies.get('rapid_auth_enabled');

  return {
    client: 'marketing site',
    page,
    query_param: window.location.search,
    variantName: analyticsStore.getState().variantName,
    variantType: analyticsStore.getState().variantType,
    variantId: analyticsStore.getState().variantId,
    loggedIn: UserStore.getState().isLoggedIn.toString(),
    ...(rapidAuthEnabledCookie && {
      rapid_auth_enabled: rapidAuthEnabledCookie,
    }),
  };
};

export default getBaseTrackingData;
